import { IsNotEmpty } from 'class-validator';

export class CreateDraftLineDto {
  /**
   * Barcode / EAN code is the more specific denominator,
   * for our products it would mean, it includes the size (Cloudstratus 1 Navy | Dust W 8.5)
   * @example '7630040540773'
   */
  @IsNotEmpty()
  public barcode: string;

  /**
   * ordered amount for the item
   */
  @IsNotEmpty()
  public quantity: number;

  // ToDo fields below should probably not be included at all on this DTO, given they can be fetched with the barcode from the products table

  /**
   * item number or product group number represents the a product and it's color (Cloudstratus 1 Navy | Dust)
   * @example '29.99866'
   */
  @IsNotEmpty()
  public itemNumber: string;

  /**
   * Full product name description with size color and size
   * @example 'Cloudstratus 1 Navy | Dust W 8.5'
   */
  @IsNotEmpty()
  public productName: string;

  /**
   * Name of the product with version number, but without color
   * @example 'Cloudstratus 1'
   */
  @IsNotEmpty()
  public productGroupName: string;
}
